import Container from "./container";
import imgUrl from "../../assets/images/urban/bg.jpeg";
import Button from "./button";
const AboutSection = () => {
  return (
    <Container>
      <div
        id="about-us"
        className="max-w-4xl flex items-start md:items-center flex-col md:flex-row gap-8 md:gap-10"
      >
        <div className="md:flex-1 md:w-auto  w-[min(350px,100%)]  hidden md:block ">
          <img
            src={imgUrl}
            className="w-full h-full object-cover"
            alt="urban about image"
          />
        </div>
        <div className=" space-y-4 md:space-y-6 flex-1">
          <p className="text-2xl">About Us</p>

          <h4
            className="text-4xl md:text-5xl font-semibold relative  before:content-[''] before:absolute
           before:w-16 before:h-0.5 before:bottom-0 before:left-0 before:bg-[#e60000] 
           pb-2
          "
          >
            URBAN Furniture Group.
          </h4>

          {/* <p className="text-xl font-semibold">
            We provide a comprehensive cabinetry design & installation service
            for your perfect space.
          </p> */}
          <p>
            Founded in 2017, URBAN Furniture Group is dedicated to providing a
            comprehensive one-stop service for crafting your perfect spaces.
            From initial design concepts to the final installation of furniture,
            we manage every aspect of the process to bring your vision to life.
          </p>
          {/* <Button label={"About Us"} /> */}
        </div>
      </div>
    </Container>
  );
};

export default AboutSection;
